import { fromCompact } from './compact';

type ReplyField = { attributeUuid: string; value: string; status: string };
type Reply = {
  trustUuid: string;
  issuerUuid: string;
  credentialUuid: string;
  status: string;
  fields: ReplyField[];
};
type PresentationPayload = { body: { replies: Reply[] } };

/** credentialUuid -> (attributeUuid -> formatted value) */
export type ValueMap = Map<string, Map<string, string>>;

export type ParseResult =
  { ok: true; valueMap: ValueMap } | { ok: false; error: string };

export function parsePresentation(compact: string): ParseResult {
  try {
    const jws = fromCompact(compact);
    const payload = jws.payload as PresentationPayload;
    const replies = payload?.body?.replies ?? [];
    const valueMap: ValueMap = new Map();
    for (const reply of replies) {
      const fieldMap = new Map<string, string>();
      for (const f of reply.fields)
        fieldMap.set(f.attributeUuid, formatValue(f.value));
      valueMap.set(reply.credentialUuid, fieldMap);
    }
    return { ok: true, valueMap };
  } catch (e) {
    console.warn('Failed to parse presentation compact:', e);
    return { ok: false, error: 'parse-error' };
  }
}

function formatValue(value: string): string {
  if (!value || value === '') return '-';
  if (typeof value !== 'string') return '-';
  if (value.length > 150) return '...';
  return value;
}
